"use client";
import { captureException } from "@sentry/nextjs";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { getChannel } from "@website/utils/channel/get-channel";
import { Channels } from "@website/utils/channel/types";
import { FC, useEffect } from "react";

export const NotFoundComponent: FC = () => {
  const baseUrl = `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/images/`;
  useEffect(() => {
    captureException("error in not-found", {
      tags: {
        errorType: "globalError",
        url: window.location.href,
        referrer: document.referrer,
        channel: getChannel() as Channels,
        appName: process.env.NEXT_PUBLIC_APP_NAME,
        appVersion: process.env.NEXT_PUBLIC_IMAGE_VERSION
      }
    });
  }, []);

  return (
    <div className="flex h-[calc(100vh-4rem)] items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet={`${baseUrl}328x168/404.png`}
          />
          <source media="(min-width: 768px)" srcSet={`${baseUrl}404.png`} />
          <img alt="not found" src={`${baseUrl}404.png`} />
        </picture>

        <p className="md:text-headline-6 text-subtitle-2">
          صفحه‌ای که دنبال آن بودید پیدا نشد!
        </p>
        <Button
          role="link"
          EndIcon={<MaterialIcon name="chevron_left" />}
          color="secondary"
          href="/"
          text="صفحه اصلی"
          variant="outline"
        />
      </div>
    </div>
  );
};
